// File: client/src/variants/mayhem/rulebook.js
// Canonical rulebook for Chess Mayhem.

const rulebook = {
  overview:
    'Total chaos. A random global modifier activates at the end of EVERY full turn — the board rotates, pieces fall, meteors strike, pawns go diagonal. Nothing stays predictable for long.',
  objective:
    'Checkmate the opponent’s king amid the madness. Both players face the same modifiers.',
  setup:
    'Standard starting position. The first modifier fires after the first full turn.',
  turnFlow: [
    'Make one normal legal move — unless a rule modifier is active, which changes how pieces move this turn.',
    'At the end of each full turn, a new random modifier fires immediately.',
    'Board modifiers reshape the board; rule modifiers change the next turn’s movement.',
  ],
  mechanics: [
    {
      title: 'Board modifiers (reshape the board)',
      items: [
        '🔄 Board Rotation — the board turns 180°.',
        '✨ Teleport — a random piece jumps to an empty square.',
        '🎲 Random Promotion — a random pawn promotes.',
        '🔀 Piece Swap — two pieces trade places.',
        '⬇️ Gravity — every piece falls to the bottom of its column.',
        '☄️ Meteor — a random non-king piece is destroyed.',
      ],
    },
    {
      title: 'Rule modifiers (change movement for a turn)',
      items: [
        '🐴 Knight Fever — every piece moves like a knight next turn.',
        '🧊 Frozen Pieces — one of the next player’s pieces cannot move.',
        '↗️ Diagonal Pawns — pawns move diagonally forward (capture straight) next turn.',
      ],
    },
  ],
  winConditions: [
    'Win by checkmate.',
    'Win if the opponent resigns or runs out of time.',
    'Stalemate is a draw (modifiers can force sudden stalemates).',
  ],
  tips: [
    'Don’t build long-term plans — Mayhem will wreck them. Play for immediate threats.',
    'Kings are never destroyed, but Gravity and Rotation can move yours into danger.',
    'A modifier can hand you a checkmate or take one away — stay flexible.',
  ],
  knownInteractions: [
    'Rule decision: a modifier fires at the END of every full turn (every 2 half-moves).',
    'Rule decision: rule modifiers (Knight Fever, Frozen, Diagonal Pawns) affect the side about to move, for exactly one turn.',
    'Rule decision: kings are never destroyed by modifiers; Meteor and Teleport skip them.',
    'Rule decision: an active modifier can leave a side in check or produce checkmate/stalemate; normal win/draw rules then apply.',
    'Shares the platform modifier catalog with Randomizer, Party, and Chaos Chess.',
    'AI: the computer plays standard chess and is not rule-modifier-aware. To keep things fair, RULE modifiers (Knight Fever, Frozen, Diagonal Pawns) are SKIPPED when they would target the computer (shown as “… fizzled against the computer”). BOARD modifiers (rotation, meteor, gravity, …) always affect both sides. In local two-player games, all modifiers affect both players normally.',
  ],
};

export default rulebook;
